import * as React from "react";
import styles from "@styles/pages/build-your-own/index.module.scss";
import {FindFavoriteProduct} from "@components/build-your-own/find-favorite-product";
import SILink from "@components/link/silink";
import {strapi} from "@api/Strapi";

// @ts-ignore
function BuildYourOwn({pdfDetails}) {

    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */
    return (
        <>
            <section className={styles.banner}>
                <img className={"img_left"}
                     src="/assets/images/banners/build_your_own/build_your_own_page_banner_left.webp"
                     alt="leftbox"/>
                <img className={"img_right"}
                     src="/assets/images/banners/build_your_own/build_your_own_page_banner_right.webp"
                     alt="right box"/>
            </section>
            <section className={styles.container}>
                <div className={'content'}>
                    <h1 className={'title_text'}>craft your honey box</h1>
                    <h2 className={'title_bold'}>super honey flavors</h2>
                    <div className={'description'}>
                        The value of freedom to choose is understood when people make it with care. The honey box that you will create by carefully making these choices can offer you the opportunity to gift someone else, bring together the flavors you want to discover, or make them more economical.<br/>
                        <br/>

                        Your purpose for creating these boxes is always special and exciting for us. With this motivation, we send you the product selections carefully made by you, by packaging them with the same care.
                        Elevate your gifting experience with super honey flavors.
                    </div>
                </div>
                <div className={'jar_boxes'}>
                    <div className={'box'}>
                        <img src='/assets/images/gift_box/small_box/open_angle_gift_box_small.webp'
                             alt="small box"/>
                        <div className={'inner_box'}>
                            <div className={'container'}>
                                <hr/>
                                <div className={'title_text'}>small box</div>
                                <div className={'description'}>7 types of honey of your choice</div>
                                <SILink classes={'link'} href={'/build-your-own/small-box'} props={{prefetch: false}}>start
                                    to build</SILink>
                            </div>
                        </div>
                    </div>
                    <div className={'box'}>
                        <img src='/assets/images/gift_box/large_box/open_angle_gift_box_large.webp'
                             alt="large box"/>
                        <div className={'inner_box'}>
                            <div className={'container'}>
                                <hr/>
                                <div className={'title_text'}>large box</div>
                                <div className={'description'}>14 types of honey of your choice</div>
                                <SILink classes={'link'} href={'/build-your-own/large-box'} props={{prefetch: false}}>start
                                    to build</SILink>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className={'bottom_rule'}/>
                <FindFavoriteProduct pdfDetails={pdfDetails}></FindFavoriteProduct>
            </section>
        </>
    )
}

export async function getServerSideProps(context: any) {

    const propsList: any = {}
    propsList.seoDetails = {
        // title: `Build Your Own | SIDR®`,
        url: context.resolvedUrl,
        // keyword: 'SIDR honey, honey box, honey flavors',
        // description: 'Build your own honey box filled with exactly the flavors and varieties of SIDR® honey you love - customize your healthy honey box today.'
    };
    try {


        let pdfDetails = null;
        const responsePdf = await strapi.getPDF();
        if (responsePdf.status == 200 && responsePdf.data && responsePdf.data.data) {
            pdfDetails = responsePdf.data.data.attributes;
        }
        propsList.pdfDetails = pdfDetails;

    } catch (e) {
    }
    return {props: propsList}
}

export default BuildYourOwn;
